import StatEval from './stat-spy.js';
import utils from './stat-utils.js';

// Default options for the plugin.
const DEFAULTS = {
	actions: {},
	category: 'Video',
	label: '',
	baseActions: {
		watch: {
			event: 'vast.firstPlay' // action = null / false -> disable sending
		},
		full_watch: {
			event: 'vast.lastPostrollEnd'
		},
		mute: {
			event: 'clickMuted'	
		},
		play: {
			event: 'clickPlay'
		},
		pause: {
			event: 'clickPause'
		},
		full_screen: {
			event: 'fullscreenOpen'
		},
		part_screen: {
			event: 'fullscreenClose'
		},
		error_report: {
			event: 'clickFeedbackOpen'
		},
		close: {
			event: 'dispose',
			value: function() {
				this.stopContentMeasure();
				return Math.round(this.watchedTime / 60);
			}
		}
	}
};

/**
 * The Stat class to eval defined function.
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends StatSpy
 */

class StatGa extends StatEval {
	constructor(player, options) {
		if (!window.ga) {
			super(player, options);
			return;
		}
		let options_ = Object.assign({}, DEFAULTS, options);
		let mergedActions = Object.assign({}, DEFAULTS.baseActions, options_.actions);

		let ev = [];
		for (let i in mergedActions) {
			mergedActions[i].event && ev.push(mergedActions[i].event);
		}
		options_.events = ev;

		super(player, options_);
		this.actions = mergedActions;
		this.category = options_.category;
		this.label = options_.label;
		this.events_ = {};
		this.lastPlayTime = null;
		this.watchedTime = 0;
		this.player = player;

		this.init();
	}

	init() {
		for (let i in this.actions) {
			let ev = this.actions[i].event;
			this.events_[ev] = this.events_[ev] || [];
			this.events_[ev].push(Object.assign({type: i}, this.actions[i]));
		}

		this.player.on('play', this.startContentMeasure.bind(this));
		this.player.on('pause', this.stopContentMeasure.bind(this));
		this.player.on('vast.lastPostrollEnd', this.stopContentMeasure.bind(this));
	}

	startContentMeasure() {
		this.lastPlayTime = new Date();
	}

	stopContentMeasure() {
		if (!this.lastPlayTime) return;
		this.watchedTime += (new Date() - this.lastPlayTime) / 1000;
		this.lastPlayTime = null;
	}

	getParams(evInfo) {
		let p = {
			'hitType': 'event',
			'eventCategory': evInfo.category || this.category,
			'eventAction': (typeof(evInfo.action) !== 'undefined' ? evInfo.action : evInfo.type)
		}
		if (evInfo.label || this.label) p['eventLabel'] = evInfo.label || this.label;

		if (evInfo.value) {
			let val = this.utils.processVal.call(this, evInfo.value);
			if (Number.isInteger(val)) p['eventValue'] = val;
		} 
		return p;
	} 

	send(ev) { 
		super.send(ev);

		this.events_[ev].forEach((info) => {
			let params = this.getParams(info);

			if (!params.eventCategory || !params.eventAction) return;
			ga('send', params);
		});
	}
}

export default StatGa;
